import jwt_decode from 'jwt-decode';

const INITIAL_STATE = {
  tipo: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOGIN':
      var decoded = jwt_decode(action.dados.tokenId);
      console.log('token decoded', decoded);
      return { ...state, tipo: decoded.tipo };
    case 'LOGOUT':
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};